// extracted by mini-css-extract-plugin
module.exports = {"container-out-of-orders":"OutOfOrders_container-out-of-orders__6T3OO"};